import { isPlatformBrowser } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, timeout } from 'rxjs';

/** Caps outbound HTTP in the browser so hung APIs cannot block UI indefinitely (runbook §7). */
@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
  private static readonly BROWSER_TIMEOUT_MS = 20_000;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!isPlatformBrowser(this.platformId)) {
      return next.handle(req);
    }
    return next.handle(req).pipe(timeout(HttpTimeoutInterceptor.BROWSER_TIMEOUT_MS));
  }
}
